import styled from 'styled-components';
import {IconButton} from '@material-ui/core';

export const IconButtonPrinter = styled(IconButton)`
  padding: 6px !important;
`;

export const LargeOrderBadgeWrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  background-color: #f8efe3;
  color: #b8894a;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;

  svg {
    flex-shrink: 0;
  }
`;
